export const GRIEVANCE_STATUS = {
  GRIEVANCE_RAISED: "RAISED",
  GRIEVANCE_INPROCESS: "INPROCESS",
  GRIEVANCE_L1_ESCALATED: "L1_ESCALATED",
  GRIEVANCE_L2_ESCALATED: "L2_ESCALATED",
  GRIEVANCE_RESOLVED: "RESOLVED",
  NEW: "NEW",
};